import { Box, Container, Typography } from "@material-ui/core"
import { clearApiToken, getOrderGetOrderGiftCardSharingText } from "api"
import { useIsDesktop } from "common/MediaQueries"
import GenericButton from "components/GenericButton/GenericButton"
import WhatsappIcon from "components/Icons/PaymentWhatsappIcon"
import TelegramIcon from "components/Icons/TelegramIcon"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import {
  initialState,
  useQuickPurchaseContext,
} from "components/QuickPurchasePage/QuickPurchaseContext"
import NextLink from "components/Reusable/Bit/NextLink"
import { shareSocialNetworkLinks } from "components/Reusable/Functions/Functions"
import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { useEffect, useRef, useState } from "react"
import styled from "styled-components"
import conffeti from "../../public/animation/Conffeti.json"
import successPayment from "../../public/animation/Purchase successful.json"

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledWrapper = styled.div<{
  $conffeti: boolean
  $isGroupPurchase?: boolean
}>`
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  position: ${(p) => (p.$conffeti ? "absolute" : "initial")};
  ${(p) => p.theme.breakpoints.up("md")} {
    width: ${(p) => !p.$conffeti && (p.$isGroupPurchase ? "405px" : "450px")};
    height: ${(p) => (p.$conffeti ? "auto" : "275px")};
    svg {
      transform: ${(p) =>
        p.$conffeti ? " scale(1) !important;" : "scale(1.5) !important;"};
    }
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    height: ${(p) => (p.$isGroupPurchase ? "250px" : "300px")};
    margin-top: 80px;
    top: ${(p) => p.$conffeti && 0};
  }
`

const StyledTitle = styled(Typography).attrs({ variant: "h1" })`
  color: ${(p) => p.theme.colors.black};
  font-size: 50px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 40px;
    line-height: 0.8;
    margin-bottom: 5px;
  }
`

const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;

  margin-bottom: 40px;
`

const StyledGenericButton = styled(GenericButton)<{
  $isGroupPurchase?: boolean
}>`
  margin-top: ${(p) => (p.$isGroupPurchase ? "44px" : "40px")};

  ${(p) => p.theme.breakpoints.up("sm")} {
    margin-top: ${(p) => (p.$isGroupPurchase ? "40px" : "26px")};
  }
`

const StyledBoxWrapper = styled(Box)<{ $isGroupPurchase?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 99;
  margin-bottom: ${(p) => (p.$isGroupPurchase ? "30px" : "0px")};
  top: -30px;

  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    flex-direction: column;
    align-items: ${(p) => (p.$isGroupPurchase ? "center" : "start")};
    margin-right: ${(p) => (p.$isGroupPurchase ? "0px" : "70px")};
    margin-bottom: ${(p) => (p.$isGroupPurchase ? "40px" : "0px")};
    top: 0;
  }
`
const StyledBox = styled(Container)<{ $isGroupPurchase?: boolean }>`
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    flex-direction: ${(p) => (p.$isGroupPurchase ? "column" : "row")};
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    margin-top: 120px;
  }
`

const StyledLottie = styled(Lottie)`
  position: relative;
  z-index: -1;
`

const defaultText = `
  color: var(--Black, var(--Primary-Black, #000));
  text-align: right;
  font-family: Speedee, NarkisBlock;

  line-height: normal;
  margin: 0;
  padding: 0;
`

const StyledBody = styled.p`
  ${defaultText}
  width: 100%;
  margin-top: 8px;
  font-size: 24px;
  font-weight: normal;
  text-align: center;
  margin-bottom: 14px;

  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: right;

    text-align: right;
  }
`

const StyledSocialTitle = styled.h2`
  ${defaultText}
  width: 100%;
  text-align: center;
  font-size: 26px;
  margin-bottom: 11px;
  font-weight: bold;

  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: right;
    margin-top: 16px;
    display: block;
  }
`

const StyledIconsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 9;
`

const StyledSvgDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    justify-content: center;
  }
`

const StyledSvgWrapper = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    cursor: pointer;
  }
`

const StyledGiftcardLottie = styled(Lottie)``

const SuccessPayment = () => {
  const {
    quickPurchaseInputValues,
    setQuickPurchaseInputValues,
    setGiftCardPrice,
  } = useQuickPurchaseContext()
  const [text, setText] = useState("")

  const RecipientName = useRef(quickPurchaseInputValues?.RecipientName)
  const { orderRecipientGuid, groupPurchaseGuid } = usePurchaseContext()

  useEffect(() => {
    // Clear the cache
    setQuickPurchaseInputValues(initialState)
    setGiftCardPrice(0)
    // If user hasn't gone through process, send them back to the start
    if (!quickPurchaseInputValues?.RecipientName) router.push("/quick-purchase")
  }, [])

  useEffect(() => {
    if (orderRecipientGuid) {
      const getData = async () => {
        const { data } = await getOrderGetOrderGiftCardSharingText(
          orderRecipientGuid,
          groupPurchaseGuid
        )
        setText(data.body)
      }
      getData()
    }
  }, [orderRecipientGuid])

  const ref = useRef(null)
  const isDesktop = useIsDesktop()
  const router = useRouter()
  const isGroupPurchase = router.pathname.includes("groupPurchases")

  useEffect(() => {
    if (document) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }, [])

  useEffect(() => {
    ref?.current?.setSpeed(0.8)
  }, [ref])

  useEffect(() => {
    !isGroupPurchase && clearApiToken()
  }, [])

  return (
    <StyledBox>
      <StyledWrapper $conffeti={false}>
        <StyledGiftcardLottie
          animationData={successPayment}
          lottieRef={ref}
          loop={false}
        />
      </StyledWrapper>
      <StyledWrapper $conffeti={true}>
        {isDesktop && <StyledLottie animationData={conffeti} loop={true} />}
        <StyledLottie animationData={conffeti} loop={true} />
      </StyledWrapper>
      <StyledBoxWrapper>
        <StyledTitle>
          איזה כיף שימחת את {RecipientName.current || ""}
        </StyledTitle>
        <StyledTitle>הגיפטקארד נשלח עכשיו!</StyledTitle>
        <StyledBody>
          ברגעים אלו אנחנו שולחים עדכון על קבלת הגיפטקארד בהודעה
        </StyledBody>

        <StyledIconsWrapper>
          <StyledSocialTitle>שתפו את המתנה שרכשתם</StyledSocialTitle>
          <StyledSvgDiv>
            <StyledSvgWrapper
              onClick={() =>
                window.open(
                  isDesktop
                    ? shareSocialNetworkLinks(text).whatsapp.desktop
                    : shareSocialNetworkLinks(text).whatsapp.mobile
                )
              }
            >
              <WhatsappIcon />
            </StyledSvgWrapper>
            <StyledSvgWrapper
              onClick={() =>
                window.open(
                  isDesktop
                    ? shareSocialNetworkLinks(text).telegram.desktop
                    : shareSocialNetworkLinks(text).telegram.mobile
                )
              }
            >
              <TelegramIcon />
            </StyledSvgWrapper>
          </StyledSvgDiv>
        </StyledIconsWrapper>

        <NextLink href="/">
          <StyledButtonWrapper>
            <StyledGenericButton
              $isGroupPurchase={isGroupPurchase}
              btnType="filled"
              width={180}
            >
              חזרה לעמוד הבית
            </StyledGenericButton>
          </StyledButtonWrapper>
        </NextLink>
      </StyledBoxWrapper>
    </StyledBox>
  )
}

export default SuccessPayment
